import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { UserPermissionKind } from '@skylab-shared/dataModel';

export interface LoggedUserInfo {
    readonly id: number;
    readonly companyId: string;
    readonly licenseAdmin: boolean;
    readonly permission: UserPermissionKind[];
}

export class LoggedUserQuery extends Query<LoggedUserInfo> { }

export class LoggedUserQueryHandlerBase implements QueryHandler<LoggedUserQuery, LoggedUserInfo> {
    public static Url = TaggedUrl.join('user', [Tags.Api]);

    public constructor(private readonly $http: HttpService) { }

    public async handleAsync(_: LoggedUserQuery): Promise<LoggedUserInfo> {
        const { data } = await this.$http.get<LoggedUserInfo>(LoggedUserQueryHandlerBase.Url);

        return {
            id: data.id,
            companyId: data.companyId,
            licenseAdmin: data.licenseAdmin,
            permission: data.permission
        };
    }
}
